import React from 'react'
import "./loading.css"
import { useContext } from 'react'
import AppContext from '../../context/AppContext'

export default function Loading()
{
    const { loading } = useContext(AppContext);

    return (
        loading ?
            (
                <div className='loading'>
                    <div className="text-center">
                        <img src="/assets/img/loading.gif" />
                    </div>
                </div>
            )
            : null
    )
}
